export default function (nga, admin, menu) {
    var _ename = 'albums';
    var _epretty = 'Album';
    var _entity = nga.entity(_ename);
    
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('code').label('Código'),
            nga.field('name').label('Nome')
        ])
        .sortField('name')
        .sortDir('asc');
    
    _entity.creationView()
        .title('Create new ' + _epretty)
        .fields([
            nga.field('code')
                    .attributes({ placeholder: 'No space allowed, 5 chars min' })
                    .validation({ required: true })                    
                    .label('Código'),
            nga.field('duration', 'number')
                    .validation({ required: true })
                    .label('Duração (em segundos)'),
            nga.field('name')
                    .validation({ required: true })
                    .label('Nome'),
            nga.field('artist')
                    .validation({ required: true })
                    .label('Artista'),
            nga.field('price', 'float')
                    .format('0.00')
                    .validation({ required: true }),
            nga.field('brand', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'brand' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Marca'),
            nga.field('language', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'language' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Idioma'),
            nga.field('style', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'style' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Estilo'),
            nga.field('type', 'reference')
                .attributes({ placeholder: 'Choose an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'type' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Tipo'),
            nga.field('format', 'reference_many')
                .attributes({ placeholder: 'Choose at least an option' })
                .targetEntity(nga.entity('tags'))
                .permanentFilters({ group: 'format' })
                .targetField(nga.field('name'))
                .validation({ required: true })
                .label('Formato'),
            nga.field('rights', 'reference_many')
                .attributes({ placeholder: 'Choose at least an option' })
                .targetEntity(nga.entity('productrights'))
                .targetField(nga.field('code'))
                .perPage(30000)
                .validation({ required: true })
                .label('Direitos'),
            nga.field('product_geoblocks', 'reference_many')
                .targetEntity(nga.entity('countries'))
                .perPage(30000)
                .targetField(nga.field('code'))
                .label('Geoblock'),
            nga.field('children', 'reference_many')
                .targetEntity(nga.entity('products'))
                .permanentFilters({ types: ['track'] })
                .targetField(nga.field('code'))
                .remoteComplete(true)
                .label('Faixas')
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/album.js